import React, { Component } from "react";
import WorkerCard from "./WorkerCard";

class WorkerGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        path: this.props.tableName,
        payload: this.props.data
      },
      fieldList: {
        worker: ["mobile", "name", "address", "requestedItems", "supplier"],
        grocer: ["mobile", "name", "requestedItems"],
        all: [
          "deliveryDate",
          "mobile",
          "name",
          "address",
          "requestedItems",
          "status",
          "supplier",
          "supplierPrice",
          "supplierNotes",
          "supplierPrices"
        ]
      }
    };
  }

  getMobileDivs = data => {
    //console.log(JSON.stringify(data));
    return data.map(rec => {
      if (
        rec.requestedItems &&
        rec.requestedItems.length > 0 &&
        rec.requestedItems[0].key !== undefined
      ) {
        return (
          <WorkerCard
            key={rec.key}
            rec={rec}
            handleEdit={this.props.handleEdit}
            phoneNumber={this.props.phoneNumber}
            path={this.props.tableName}
            tableName={this.props.tableName}
            firebase={this.props.firebase}
            updateRecord={this.props.updateRecord}
            onNotifyUsers={this.props.onNotifyUsers}
            allSuppliers={this.props.allSuppliers}
            stage={this.props.stage}
            repeatOrder={this.props.repeatOrder}
          />
        );
      }
    });
  };

  render() {
    if (
      this.props.data &&
      this.props.data !== undefined &&
      this.props.data.length > 0
    ) {
      return <div>{this.getMobileDivs(this.props.data)}</div>;

      //return this.getRows(this.props.data);
    } else {
      if (this.props.dataIsLoaded) {
        return (
          <div>
            <div
              style={{
                textAlign: "center",
                padding: "10px"
              }}
            >
              You do not have any orders.
            </div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              margin: "15px"
            }}
          >
            <div
              style={{
                textAlign: "center"
              }}
            >
              Seems like you are on a slow network, we are loading data please
              wait a moment...
            </div>
          </div>
        );
      }
    }
  }
}

export default WorkerGrid;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/WorkerGrid.jsx